import * as React from 'react';
import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import svg from '../../assets/icons/pocket.svg';
import { BreadCrumbs } from '../../components/breadCrumbs/BreadCrumbs';
import { Header } from '../../components/header/Header';
import { Loader } from '../../components/loader/Loader';
import { ModalDetails } from '../../components/modals/modalDetails/ModalDetails';
import { ModalSuccess } from '../../components/modals/modalSuccess/ModalSuccess';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { useAppSelector } from '../../hooks/useAppSelector';
import { IQualification } from '../../models/service/service';
import { getOpportunitiesById } from '../../store/actions/actions';
import { MainInfo } from './mainInfo/MainInfo';
import { useStyles } from './opportunityDetails.styles';
import { Volunteers } from './volunteers/Volunteers';

export const OpportunityDetails = (): JSX.Element => {
  const opportunities = useAppSelector((state) => state.organizerReducer.opportunitiesById);
  const successVisible = useAppSelector((state) => state.organizerReducer.successVisible);
  const searchString = new URLSearchParams(window.location.search);
  const id = searchString.get('id');
  const [open, setOpen] = useState(false);
  const dispatch = useAppDispatch();
  const classes = useStyles();

  useEffect(() => {
    getOpportunitiesById(id)(dispatch);
  }, []);

  return (
    <>
      <Header />
      {opportunities
        ? <Box className={classes.mainBlock}>
          <h3 className={classes.title}>Details</h3>
          <BreadCrumbs />
          <Box className={classes.contentBlock}>
            <MainInfo setOpen={setOpen} />
            {!!opportunities.qualifications.length && (
              <Box>
                <h3 className={classes.title}>Required qualifications</h3>
                {opportunities.qualifications.map((item: IQualification) => (
                  <p className={classes.qual}><img src={svg} alt={svg} />{item.content}</p>
                ))}
              </Box>
            )}
            <Box>
              <h3 className={classes.title}>Details</h3>
              <p className={classes.paragraph}>{opportunities.details}</p>
            </Box>
            <Box>
              <h3 className={classes.title}>Cancellation policy</h3>
              <p className={classes.paragraph}>{opportunities.cancellationPolicy}</p>
            </Box>
            <Volunteers />
          </Box>
          <ModalDetails
            open={open}
            setOpen={setOpen}
            name={opportunities.name}
          />
          <ModalSuccess
            open={successVisible}
            text={'All changes made to the opportunity have been successfully saved!'}
            title={'Saved'}
          />
        </Box>
        : <Loader />
      }
    </>
  );
};
